const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function isValidEmail(value) {
    return EMAIL_PATTERN.test(String(value).trim());
}

export default isValidEmail;
export { EMAIL_PATTERN };
